import { MapIndicator } from 'types'

type MapIndexAvailability = {
  [index in MapIndicator]: boolean
}

interface AvailableIndexVariables {
  selectedMapIndex: MapIndicator
  mapIndexAvailability: MapIndexAvailability
}

const getAvailableIndex = ({ selectedMapIndex, mapIndexAvailability }: AvailableIndexVariables) => {
  if (!mapIndexAvailability[selectedMapIndex]) return 'irrigation'
  return selectedMapIndex
}

export const IndicesUtils = {
  getAvailableIndex,
}
